
import React from "react"
import { Col, Container, Row, Stack} from "react-bootstrap"

// assets imports
import logo_prefeitura_trans from "assets/logo_prefeitura_transparente.png"
import contact_facebook from "assets/icon_facebook.png"
import contact_twitter from "assets/icon_twitter.png"
import contact_instagram from "assets/icon_instagram.png"
import contact_youtube from "assets/icon_youtube.png"

function FooterSectionPrefeituraDeAracaju()
{
    return (
        <div className="text-align-center">
            <p className="fw-bold text-center pt-1 fs-6">Prefeitura de Aracaju</p>
            <Stack direction="horizontal" gap={5}>
                <img src={logo_prefeitura_trans} alt="logo" />
                <p className="fs-7">
                   Centro Administrativo Prefeito Aloísio Campos<br/>
                   Rua Frei Luís Canelo de Noronha, 42<br/>
                   Conj. Costa e Silva<br/>
                   CEP 49097-270
                </p>
            </Stack>
        </div>
    )
}

function FooterSectionLinksUteis()
{
    const linkFacebook = "https://www.facebook.com/prefaracaju/"
    const linkTwitter = "https://twitter.com/PrefAracaju?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
    const linkInstagram = "https://instagram.com/prefaracaju?igshid=YWJhMjlhZTc="
    const linkYoutube = "https://www.youtube.com/channel/UCrkicSuCVQNE2CtJeMY9aPw"
    return (
        <Container>
            <p className="fw-bold text-center pt-1 fs-6">Redes da prefeitura</p>
            <div className="text-center">
                <a href={"https://www.aracaju.se.gov.br/"} className="text-white text-decoration-none fs-7 p-2">Prefeitura de Aracaju</a>
                <Row className="text-center my-3">
                    <Col>
                        <a href={linkFacebook}><img src={contact_facebook} alt="link de contato facebook" /></a>
                    </Col>
                    <Col>
                        <a href={linkTwitter}><img src={contact_twitter} alt="link de contato twitter" /></a>
                    </Col>
                </Row>
                <Row className="text-center my-3">
                    <Col>
                        <a href={linkInstagram}><img src={contact_instagram} alt="link de contato instagram" /></a>
                    </Col>
                    <Col>
                        <a href={linkYoutube}><img src={contact_youtube} alt="link de contato youtube" /></a>
                    </Col>
                </Row>
            </div>
        </Container>
    )
}

export default function Footer()
{
    return (
        <footer className="bg-primary text-white mt-auto">
            <Container>
                <Row>
                    <Col>
                        < FooterSectionPrefeituraDeAracaju />
                    </Col>
                    <Col>
                        < FooterSectionLinksUteis />
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}